import { Injectable } from '@angular/core';
import { User, OSConfig } from './types';

interface ValidatorContext {
  regimenClass?: string;
  userPhoneModel?: string;
}

@Injectable({
  providedIn: 'root'
})
export class EligibilityValidatorService {
  private readonly validators: { [key: string]: (user: User, expected: any, context?: ValidatorContext) => boolean } = {
    languagePreference: (user: User, expected: string[]): boolean => {
      const userLang = (user?.get('languagePreference') || '').toLowerCase();
      return expected.map((val: string): string => val.toLowerCase()).includes(userLang);
    },
    order_state: (user: User, expected: string[]): boolean => {
      const userOrderState = (user?.get('orderState') || '').toUpperCase();
      return expected.map((val: string): string => val.toUpperCase()).includes(userOrderState);
    },
    Class: (_user: User, expected: string[], context?: ValidatorContext): boolean =>
      expected.map((val: string): string => val.toLowerCase())
        .includes((context?.regimenClass || '').toLowerCase()),
    Gender: (user: User, expected: string[]): boolean =>
      expected.includes(user?.get('Gender')),
    minAge: (user: User, expected: number): boolean => {
      const userAge = user?.get('Age');
      return userAge >= expected;
    },
    phoneModel: (_user: User, expected: string[], context?: ValidatorContext): boolean => {
      if (!context?.userPhoneModel) return false;
      const allowedModels = expected.map((m: string): string => m.toLowerCase());
      return allowedModels.includes(context.userPhoneModel.toLowerCase());
    }
  };

  validateCriteria(
    user: User,
    osConfig: OSConfig,
    regimenClass: string,
    userPhoneModel: string
  ): boolean {
    const context: ValidatorContext = {
      regimenClass,
      userPhoneModel
    };

    return Object.keys(osConfig).every((key: string): boolean => {
      const expectedValue = osConfig[key];
      const validator = this.validators[key];
      return validator
        ? validator(user, expectedValue, context)
        : user?.get(key) === expectedValue;
    });
  }
}
